import { Button, type ButtonProps } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export function GradientButton({ children, ...props }: ButtonProps) {
  return (
    <Button
      {...props}
      className={cn(
        'relative overflow-hidden bg-white text-black hover:bg-white/90 font-bold shadow-sm transition-colors duration-200',
        props.className,
      )}
    >
      {children}
      {!props.disabled && (
        <div className="absolute inset-[-2px] bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shine" />
      )}
    </Button>
  )
}
